export default __webpack_public_path__ + "static/media/PhoneRinging.9c1ed313.mp3";